<div class="screen-title">Add supplier contact</div>

<contact-edit [model]="model | async" (onSave)="saveContact($event)" (onCancel)="cancel()"></contact-edit>
